<!-- Lame 1 Push Card Component -->
@if (pushLame1) {
  <section>
    <sd-component-wrapper [themesConfig]="lameConfig?.lame1?.backgroundTheme" [brand]="brandCorner">
      @if (pushLame1) {
        <sd-push-card sd-component-wrapper-component
                      [brand]="brandCorner"
                      [pushSize]="PushSizeEnum.l"
                      [push]="pushLame1"
                      [textConfig]="lameConfig?.lame1?.textConfig || PositionEnum.left"
                      [mediaConfig]="lameConfig?.lame1?.mediaConfig || PositionEnum.right"
                      [mediaAsBackground]="false"
                      [themesConfig]="lameConfig?.lame1?.theme || BrandThemesEnum.brand"
                      [titleLevel]="1"
                      [twicPicsAutoSize]="false"
                      [isDescription]="isDescription"
                      [isFit]="isFit"
                      [hasModal]="hasModal"
                      (clicked)="onClick($event)"
        />
      }
    </sd-component-wrapper>
  </section>
}
@if (teasers?.length > 0) {
  <sd-teaser
    id="SdTeaserComponent_CategoryPage_1"
    [brand]="brandCorner"
    [data]="teasers"
    [titleLevel]="1"
    [twicPicsAutoSize]="false"
    (clicked)="onClick($event)"
  />
}
<!-- Lames 2 et 3 DynamicBody1 slot -->
<sd-theme-wrapper [brand]="brandCorner">
  <section>
    <cx-page-slot position="DynamicBody1" />
  </section>
</sd-theme-wrapper>
@if (!isLazyLoadingEnabled || (lame1Loaded && eagerLoaded)) {
  <!-- Lame 4 Sub-category component -->
  @if (subcategories?.length > 0) {
    <section>
      <sd-component-wrapper
        [brand]="brandCorner"
        [content]="contentWrapper"
        [titleLevel]="contentWrapper?.heading?.titleLevel"
        [themesConfig]="lameConfig?.lame4?.backgroundTheme"
        [textConfig]="contentWrapper?.heading?.textConfig || PositionEnum.center"
        [layoutTextConfig]="subCatTextConfig"
      >
        @if (subcategories?.length > 0) {
          <wc-sub-category sd-component-wrapper-component
                           [linkCardSubcategories]="linkCardSubcategories"
                           [subcategoriesInput]="subcategories"
                           [themeConfig]="lameConfig?.lame4?.backgroundTheme"
                           (wrapper)="getContentWrapper($event)"
          />
        }
      </sd-component-wrapper>
    </section>
  }
  <!-- Lames 5 et 6 DynamicBody2 slot -->
  <sd-theme-wrapper [brand]="brandCorner">
    <section>
      <cx-page-slot position="DynamicBody2" />
    </section>
  </sd-theme-wrapper>
  <!-- Lame 7 Arguments -->
  @if (argumentsLame7) {
    <section>
      <sd-arguments
        id="SdArgumentsComponent_CategoryPage_1"
        class="is-component"
        [brand]="brandCorner"
        [data]="argumentsLame7"
        [textConfig]="lameConfig?.lame7?.textConfig || PositionEnum.left"
        [layout]="lameConfig?.lame7?.layout || ArgumentsLayoutEnum.default"
        [themesConfig]="lameConfig?.lame7?.theme || ThemesEnum.default"
        [layoutTextConfig]="lameConfig?.lame7?.mediaConfig || PositionEnum.right"
        (clicked)="onClick($event)"
      />
    </section>
  }
  <!-- Lame 8 DynamicBody3 slot -->
  <sd-theme-wrapper [brand]="brandCorner">
    <section>
      <cx-page-slot position="DynamicBody3" />
    </section>
  </sd-theme-wrapper>
  @if (faqs?.length > 0) {
    <section>
      <sd-component-wrapper
        [brand]="brandCorner"
        [content]="faqWrapper"
        [themesConfig]="lameConfig?.faq?.backgroundTheme"
      >
        @if (faqs?.length > 0) {
          <wc-base-faq sd-component-wrapper-component
                       [faqEntries]="faqs"
                       [titleLevel]="2"
          />
        }
      </sd-component-wrapper>
    </section>
  }
  <sd-theme-wrapper [brand]="brandCorner">
    <section>
      <cx-page-slot position="SEO" />
    </section>
  </sd-theme-wrapper>
}
